import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { getLayoutConfig, layoutConfigs } from '@app/libs/layoutConfig';

export type LayoutType = 'default' | 'simple' | 'dashboard' | 'auth' | 'none' | 'dev';

export const useLayout = () => {
  const router = useRouter();

  const layoutConfig = useMemo(() => {
    if (!router.asPath) {
      return layoutConfigs.default;
    }

    const path = router.asPath.split('?')[0]; // Remove query params
    return getLayoutConfig(path);
  }, [router.asPath]);

  return layoutConfig;
};
